import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { prettyDate, prettyFloatMoney } from '@/helpers/utils';
import IconChevron from './icon_chevron.svg?react';
import s from './index.module.scss';

const COLLAPSED_ROW_COUNT = 2;

export const Transactions = ({ data = [] }) => {
  const { t } = useTranslation('compliance');
  const [isExpanded, setIsExpanded] = useState(false);

  const isEmpty = !data || data.length === 0;

  if (isEmpty) return null;

  const hasToggle = data.length > COLLAPSED_ROW_COUNT;
  const visibleRows = hasToggle && !isExpanded ? data.slice(0, COLLAPSED_ROW_COUNT) : data;
  const total = data.reduce((acc, item) => acc + item.amount, 0);

  return (
    <div className={s.wrapper}>
      <div className={s.header}>
        <div className="f-small-accent">
          {t('transactions.transactions', { count: data.length })}
        </div>
        <div className="f-small-regular">
          {t('transactions.total', { total: prettyFloatMoney(total) })}
        </div>
      </div>
      <div className={s.table}>
        {visibleRows.map((item, idx) => (
          <div key={idx} className={s.row}>
            <div className="f-small-accent">{prettyDate(item.date)}</div>
            <div className="f-small-regular">
              {prettyFloatMoney(item.amount)}
            </div>
          </div>
        ))}
        {hasToggle && (
          <button
            type="button"
            className={classnames(s.toggle, isExpanded && s.toggle_expanded)}
            onClick={() => setIsExpanded(prev => !prev)}
          >
            <span className="f-small-regular">
              {isExpanded ? t('transactions.hide') : t('transactions.view_all')}
            </span>
            <IconChevron className={s.toggle__icon} />
          </button>
        )}
      </div>
    </div>
  );
};